import React, { CSSProperties } from 'react'

import { AnimatedHamburgerButtonStyled } from './AnimatedHamburgerButton.styles'

export interface IAHBProps {
  isBurger: boolean;
  transitionDuration: number;

  onClick?: () => void;
};


export const AnimatedHamburgerButton: React.FC<IAHBProps> = ({ isBurger, transitionDuration, onClick }) => {
  const transStyle = transitionDuration > 0 ? {  transition: `${transitionDuration}s` } as CSSProperties : undefined;

  return (
    <AnimatedHamburgerButtonStyled isBurger={isBurger} onClick={onClick} disabled={ onClick === undefined } className='AnimatedHamburgerButton'>
      <div>
        { /* Add transition here not in styled as this won't produce a different class for each possible value */ }
        <div style={transStyle} className='AHBTopBun'></div>
        <div style={transStyle} className='AHBPatty'></div>
        <div style={transStyle} className='AHBBottomBun'></div>
      </div>
    </AnimatedHamburgerButtonStyled>
  );
};

export default AnimatedHamburgerButton;